import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { usePlayerStore } from '../store/player';
import { PixelText } from '../ui/PixelText';

/**
 * Gate for game routes.
 * - While `authStatus === 'pending'` (first restore attempt in flight), render a loading shell
 *   instead of bouncing the user. This prevents hard-refresh on /roster (etc.) from racing
 *   the redirect-to-login → redirect-back-to-/ ping-pong.
 * - Once `authStatus === 'authenticated'`, render children.
 * - Once `authStatus === 'anonymous'`, redirect to /login.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const me = usePlayerStore(s => s.me);
  const authStatus = usePlayerStore(s => s.authStatus);

  if (authStatus === 'pending') {
    return (
      <main className="min-h-screen flex items-center justify-center p-6">
        <PixelText color="cyan" size="lg" className="opacity-70">…</PixelText>
      </main>
    );
  }

  if (!me) return <Navigate to="/login" replace />;

  return <>{children}</>;
}
